import cookie from 'js-cookie';
import { createI18n } from 'vue-i18n';

const LANG_COOKIE = 'locale';

type Context = Record<string, Record<string, string>>
const context: Context = import.meta.glob('./locales/*.json', { eager: true });
const files = Object.keys(context);

function loadLocaleMessages(): Context {
  const messages: Context = {};
  files.forEach((key: string) => {
    const matched = /([a-z]{2})\.([a-z]{4})/i.exec(key);
    if (matched && matched.length > 1) {
      const locale = matched[1] as string;
      messages[locale] = {
        ...messages[locale],
        ...context[key] as Record<string, string>,
      };
    }
  });
  return messages;
}

const getLocale = () => {
  const storedLocale = cookie.get(LANG_COOKIE);

  if (storedLocale) {
    return storedLocale;
  }

  const navigatorLocale = navigator.language.split('-')[0];
  if (files.some((key) => key.includes(`.${navigatorLocale}.`))) {
    return navigatorLocale;
  }

  return 'en';
};

const messages = loadLocaleMessages();
const locales = Object.keys(messages);
const userPreference = getLocale();
const validPreference = userPreference && locales.includes(userPreference);

export default createI18n({
  fallbackLocale: 'en',
  globalInjection: true,
  legacy: false,
  locale: validPreference ? userPreference : 'en',
  messages: loadLocaleMessages(),
  warnHtmlMessage: false,
});
